import React, { Component } from 'react'
import FontW7 from "../Font/FontW7";
import FontW5 from "../Font/FontW5";
import FontW9 from "../Font/FontW9";
import { Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        maxWidth: '1170px',
        flexGrow: 1,
        margin: '0 auto',
    },
    divPadding: {
        height: '100px',
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        },
    },
    title: {
        fontSize: "24pt",
        lineHeight: 1.5,
        // [theme.breakpoints.down('sm')]: {
        //     fontSize: "22pt",
        // },
    },
    paddingLeft: {
        paddingLeft: '50px',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0',
        },
    },
    content: {
        paddingLeft: '10px',
        paddingTop: '25px',
        fontSize: '16pt',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
            textAlign: 'center',
        },
    },
    name: {
        fontSize: "43pt",
        textAlign: 'left',
        float: 'right',
        marginRight: 30,
        [theme.breakpoints.down('sm')]: {
            fontSize: "35pt",
        },

    },

    legend: {
        marginTop: '0px',
        lineHeight: '26px',
        textAlign: 'left',
        fontSize: "18pt",
        float: 'right',
    },

    img: {
        [theme.breakpoints.up('md')]: {
            float: 'right',
            marginRight: 100,
        },
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto'
        },
    }

})

class About extends Component {
    render() {
        const { img, title, classes } = this.props
        return (
            <div data-scroll-index="1" id="section-1" className="clearfix about-style-2" >
                <Grid
                   container
                   className={classes.root}
                   justify={"space-evenly"}
                >
                    <Grid container item md={6} xs={12} alignItems={"flex-end"}>
                        <Grid item xs={12}>
                            <img
                               src={img}
                               alt={title}
                               className={"img-responsive wow fadeInRight " + classes.img}
                               data-wow-delay=".6s"
                            />
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <div className={classes.divPadding}/>
                        <div className=" text-body wow fadeInLeft paddingLeft" data-wow-delay=".3s">
                            <FontW7 className={classes.title}>{title}</FontW7>
                            <p className={classes.content}>
                                <FontW5>
                                    横浜国立大学工学部を卒業後、教育研修業にて起業。30歳過ぎには、研修の受講生は延べ10万人を超え、著書も累計10万部を突破した。しかし、真の自己が「発明家」であることに気づき、32歳からは、研究開発に明け暮れ、引き篭り生活を続ける。その間に、自己を統合する理論や技術、1on1セッションを可能にするAIなどの開発にいたる。
                                </FontW5>
                            </p>
                            <Grid container alignItems={"flex-end"}>
                                <Grid item xs={12}>
                                    <p className={classes.legend}>
                                        <FontW5>
                                            株式会社インヴェンスター<br/>
                                            代表取締役 発明家
                                        </FontW5>
                                    </p>
                                </Grid>
                                <Grid item xs={12}>
                                    <h2 className={classes.name}>
                                        <FontW9>生田 知久</FontW9>
                                    </h2>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(About)
